import { config } from "config";
import { SetEnquiresPayload, EnquireState } from ".";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { SelectOption } from "components/atoms/Select";

const default_page_size = config.PAGE_SIZE;
const initialState: EnquireState = {
  count: 0,
  enquires: [],
  enquire: null,
  loading: true,
  refresh: 0,
  current_filters: {},
  refreshLoader: false,
  enquireOptions: [],

  filters: { page: 1, pageSize: default_page_size },
};

export const enquireSlice = createSlice({
  name: "enquire",
  initialState,
  reducers: { 
    clear_search: (state) => {
      state.enquires = [];
      state.enquireOptions = [];
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    
    updateEnquire: (state, action) => {
      const { id, enquire } = action.payload;
      state.enquires.every(({ _id }, i) => {
        if (id === _id) {
          state.enquires[i] = enquire;
          return false;
        }
        return true;
      });
    },
    deleteEnquireById: (state, action) => {
      const id = action.payload;
      state.enquires.every(({ _id }, i) => {
        if (id === _id) {
          state.count -= 1;
          state.enquires.splice(i, 1);
          return false;
        }
        return true;
      });
    },
    setEnquire: (state, action) => {
      state.enquire = action.payload;
    },

    addEnquire: (state, action) => {
      state.enquires.unshift(action.payload);
    },

    setEnquires: (state, action: PayloadAction<SetEnquiresPayload>) => {
      const { count, enquires } = action.payload;
      state.count = count;
      state.refreshLoader = false;

      let options: SelectOption[] = [];
      enquires.forEach(({ _id, fullName, email }: any) =>
        options.push({ value: _id, label: fullName + " " + email })
      );
      state.enquires = enquires;
      state.enquireOptions = options;
    },
    setSearchEnquires: (state, action: PayloadAction<SetEnquiresPayload>) => {
      const { count, enquires } = action.payload;
      state.count = count;
      state.refreshLoader = false;

      let options: SelectOption[] = [];
      enquires.forEach(({ _id, fullName,email }: any) =>
        options.push({ value: _id, label: fullName + " "  +" - " +email })
      );
      state.enquires = enquires;
      state.enquireOptions = options;
    },
    setPage: (state, action: PayloadAction<number>) => {
      state.refresh += 1;
      state.refreshLoader = true;
      state.filters.page = action.payload;
    },
    refresh: (state) => {
      state.refresh += 1;
      state.refreshLoader = true;
    },
    resetPage: (state) => {
      state.filters.page = 1;
    },
    setFilters: (state, action) => {
      state.filters = action.payload;
      state.refreshLoader = true;
    },
    setCurrentFilters: (state, action) => {
      state.current_filters = action.payload;
    },
    resetFilters: (state) => {
      state.refresh += 1;
      state.refreshLoader = true;
      state.filters = initialState.filters;
      state.current_filters = initialState.current_filters;
    },
  },
});

const enquireReducer = enquireSlice.reducer;

export const enquireActions = enquireSlice.actions;
export default enquireReducer;
